import dayjs from 'dayjs'
import 'dayjs/locale/th'
export function fnDateTh(date = new Date()) {
  return dayjs(date).locale('th').add(543, 'year')
}
